/**
 * @name setLoading.js
 * @description ローディング処理
 */
import loadImages from '../libs/LoadImages';

//プロパティ
const setPropaty = () => {
    return {
        html: document.querySelector('html'),
        body: document.querySelector('body'),
        splash: document.querySelector('#splash'),
        video: document.querySelector('#video'),
    }
}

class setLoading {
    constructor() {
        this.propaty = setPropaty();

        window.addEventListener("load", async () => {
            await loadImages()
            let $myWindow = "visited";
            this.propaty.body.style.setProperty('--alpha', 1);
            if (window.name.indexOf($myWindow) != -1) {
                this.propaty.splash && this.propaty.splash.parentElement.remove();
                this.propaty.video && this.propaty.video.play();
                this.propaty.html.dataset.state = '';
            } else {
                window.name = $myWindow;
                if (this.propaty.splash) {
                    this.propaty.splash.play(),
                        this.propaty.splash.addEventListener('ended', () => {
                            this.propaty.body.classList.add('is-loaded');
                            this.propaty.video.play();
                            this.propaty.html.dataset.state = '';
                            setTimeout(() => {
                                this.propaty.splash.parentElement.remove();
                            }, 600);
                        });
                } else { 
                    this.propaty.html.dataset.state = '';
                }
            }
        });
    }
}

export default setLoading;